import React from 'react';
import { Container, Typography, Box, Button, Card, } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Instagram } from '@mui/icons-material';

function Home() {
    const navigate = useNavigate();

    return (
        <Box sx={{
            position: 'relative',
            width: '100%',
            minHeight: '100vh',
            overflowX: 'hidden',  // Prevent horizontal scrolling
            paddingTop: '80px',
            boxSizing: 'border-box'
        }}>

            {/* Video Banner Inside Main Container */}
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1, color: 'black', paddingBottom: '30px' }}>
                <Box sx={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: 2,
                    overflow: 'hidden',
                    boxShadow: 3
                }}>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{
                            width: '100%',
                            height: 'auto',
                            display: 'block',
                            objectFit: 'cover' // Keeps the aspect ratio intact while filling the space
                        }}
                    >
                        <source src={require('../Images/Banner/banner.mp4')} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </Box>

            </Container>

            {/* Page Content */}
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1, color: 'black', paddingBottom: '50px' }}>
                {/* Introductory Section */}
                <Box sx={{
                    textAlign: 'center',
                    backgroundColor: 'white',
                    padding: 4,
                    borderRadius: 2,
                    boxShadow: 3,
                    marginBottom: 4,
                    boxSizing: 'border-box'
                }}>
                    <Typography variant="h4" gutterBottom>
                        Welcome to Great Lakes Golf Academy
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Join us for personalized golf lessons tailored to improve your skills and help you achieve your golfing goals.
                        Whether you're a beginner or an advanced player, our expert instructors are here to guide you to success.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate("/lessons")}
                        sx={{ marginTop: 2 }}
                    >
                        Book Your Lesson Now
                    </Button>
                </Box>

<Card sx={{ marginTop: 4, padding: 2, boxShadow: 3, boxSizing: 'border-box' }}>
  <Box sx={{ py: 4, textAlign: 'center' }}>
    <Typography variant="h5" color="text.secondary" gutterBottom>
      Our Partners:
    </Typography>

<Box sx={{ py: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
  {/* Smash Factory Card */}
  <Card sx={{ maxWidth: 600, width: '100%', p: 3, boxShadow: 3 }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2, gap: 2 }}>
      <Box
        component="img"
        src={require('../Images/icons/smashfactory.png')}
        alt="Smash Factory"
        sx={{ width: 48, height: 48, cursor: 'pointer' }}
        onClick={() => window.open('https://smashfactory.ca', '_blank')}
      />
      <Typography variant="h5" textAlign="center">
        Smash Factory
      </Typography>
    </Box>
    <Typography variant="body1" paragraph textAlign="center">
      The Smash Factory is a boutique fitting experience for the golfer who wants the very best equipment for their game. Using state-of-the-art equipment, Marc will analyze your game and provide a comprehensive diagnosis of where you can improve, either by customizing new clubs or retrofitting your current set.
    </Typography>
  </Card>

  {/* Fit Club Card */}
  <Card sx={{ maxWidth: 600, width: '100%', p: 3, boxShadow: 3 }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2, gap: 2 }}>
      <Box
        component="img"
        src={require('../Images/icons/fitclub.jpg')}
        alt="Fit Club"
        sx={{ width: 48, height: 48, cursor: 'pointer' }}
        onClick={() => window.open('https://fitclubbootcamps.ca/', '_blank')}
      />
      <Typography variant="h5" textAlign="center">
        Fit Club
      </Typography>
    </Box>
    <Typography variant="body1" paragraph textAlign="center">
      With years of success and experience, FitClub is capable of analyzing your body and creating a T.P.I. fitness plan that will help you reach your golf goals. We will guide you with the best program for your body and will work with you to keep you on track and motivated to reach your goals.
    </Typography>
  </Card>
</Box>
  </Box>
</Card>


                <Card sx={{
                    marginTop: 4,
                    padding: 2,
                    boxShadow: 3,
                    boxSizing: 'border-box'
                }}>
                    <Instagram sx={{ verticalAlign: 'middle', fontSize: 30 }} />
                    <br />
                    <br />
                    <Typography justifyContent="center" textAlign="center" variant="h5" color="text.secondary" paragraph>
                        Follow us on Instagram for the latest updates and tips!
                        <br /><br />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => window.open("https://www.instagram.com/greatlakesgolfacademy/")}
                        >
                            Follow Us
                        </Button>
                    </Typography>

                    
                </Card>
            </Container>
        </Box>
    );
}

export default Home;
